import { Injectable } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SessionFactory } from '../caches/session.factory';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    sessionFactory: SessionFactory;

    constructor(protected localStorage: LocalStorage) {
        this.sessionFactory = SessionFactory.getInstance();
    }

    setString(key: string, value: any): void {
        localStorage.setItem(key, value);
    }

    getString(key: string): string {
        return localStorage.getItem(key);
    }

    setObject(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getObject(key: string): any {
        // if (parseInt(localStorage.getItem('fldr_Id')) != this.sessionFactory.fldr.fldr_Id) {
        //     return null;
        // }

        return JSON.parse(localStorage.getItem(key));
    }

    removeItem(key: string): any {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}